/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

// Scrollable Element

export const SCROLLABLE_ELEMENT_PADDING_TOP = 20;
// export const SCROLLABLE_ELEMENT_PADDING_TOP_WITH_TOOLBAR = 8;

// Cell sizing related
export const CELL_MARGIN = 8;
export const CELL_RUN_GUTTER = 28;
export const CODE_CELL_LEFT_MARGIN = 32;

export const EDITOR_TOOLBAR_HEIGHT = 0;
export const BOTTOM_CELL_TOOLBAR_GAP = 18;
export const BOTTOM_CELL_TOOLBAR_HEIGHT = 22;
export const CELL_STATUSBAR_HEIGHT = 22;

// Margin above editor
export const CELL_TOP_MARGIN = 6;
export const CELL_BOTTOM_MARGIN = 6;

export const MARKDOWN_CELL_TOP_MARGIN = 8;
export const MARKDOWN_CELL_BOTTOM_MARGIN = 8;

// Top and bottom padding inside the monaco editor in a cell, which are included in `cell.editorHeight`
// export const EDITOR_TOP_PADDING = 12;
export const EDITOR_BOTTOM_PADDING = 4;
export const EDITOR_BOTTOM_PADDING_WITHOUT_STATUSBAR = 12;

export const CELL_OUTPUT_PADDING = 14;

export const COLLAPSED_INDICATOR_HEIGHT = 24;

export const MARKDOWN_PREVIEW_PADDING = 8;
